// 应用版本配置
// 每次发布新版本时，请更新此文件中的版本号

export const APP_VERSION = '2.0.0';
export const BUILD_DATE = '2025-12-26';
export const CACHE_VERSION = `v${APP_VERSION}-${BUILD_DATE.replace(/-/g, '')}`;

// 版本更新日志
export const CHANGELOG = {
  '2.0.0': [
    '✅ 新增 iOS 描述文件下载功能',
    '✅ 实现 Service Worker 智能缓存',
    '✅ 添加离线引导页面',
    '✅ 优化版本更新机制，确保用户始终看到最新内容',
    '✅ 增强网络容错能力，域名被墙也能访问备用地址'
  ],
  '1.2.0': [
    '优化下载页面 UI 设计',
    '添加多平台支持',
    '提升性能和响应速度'
  ]
};

// 打印版本信息到控制台（仅开发环境）
export function printVersionInfo() {
  // 仅在开发环境显示版本信息
  if (process.env.NODE_ENV === 'development') {
    console.log(
      '%c Julian AIGPT PRO %c v' + APP_VERSION + ' ',
      'background:#ff6b35; padding: 3px; border-radius: 3px 0 0 3px; color: #fff',
      'background:#f7931e; padding: 3px; border-radius: 0 3px 3px 0; color: #fff',
    );
    console.log('📅 构建日期:', BUILD_DATE);
    console.log('📦 缓存版本:', CACHE_VERSION);
    
    if (CHANGELOG[APP_VERSION]) {
      console.log('\n🎉 更新内容:\n' + CHANGELOG[APP_VERSION].join('\n'));
    }
  }
}

// 检查是否需要更新
export function checkVersionUpdate() {
  const storedVersion = localStorage.getItem('app_version');
  const currentVersion = APP_VERSION;
  
  if (storedVersion !== currentVersion) {
    console.log(`🔄 版本更新: ${storedVersion || '未知'} -> ${currentVersion}`);
    localStorage.setItem('app_version', currentVersion);
    return true;
  }
  
  return false;
}

